import * as I18n from 'circe/I18n';
import { morphFormAddressToRequestPayload } from 'domain/batch/sheets/utils';

export const formatRequest = (truckDetails) => {
  const { baseLocation } = truckDetails;
  const { coordinate, city } = morphFormAddressToRequestPayload(baseLocation);
  const { latitude, longitude } = coordinate;
  const {
    truckType: type,
    capacity,
    license,
    within: maxDistance,
    length: capacityLenght,
    width: capacityWidth,
    height: capacityHeight,
    maxWeight,
    fleetId,
    details,
    equipmentId,
    accountId,
    ownershipType,
  } = truckDetails;

  const {
    maxTrailers, axles, label, startingWeight, tareWeight, size,
  } = details;
  const { length, width, height } = size;

  const data = {
    fleetId,
    maxDistance,
    baseLocation: {
      latitude,
      longitude,
    },
    homeCity: city,
    params: {
      address: null,
      axles,
      vehicleOwnershipType: ownershipType,
      capacity: {
        height: capacityHeight,
        length: capacityLenght,
        width: capacityWidth,
      },
      licensePlate: license,
      maxTrailers,
      maxWeight,
      name: equipmentId || label,
      owner: accountId,
      size: {
        length,
        width,
        height,
      },
      startingWeight,
      tareWeight,
      tempRange: {
        excludeMax: true,
        excludeMin: true,
        maximum: 0,
        minimum: 0,
      },
      type,
      vin: null,
    },
    vehicleId: null,
  };

  return data;
};
export const isLicensePlate = (val) => (val.length === 10
  ? undefined
  : I18n.str('invalidLicensePlate', 'Please enter a valid license plate ex: 0000 A A A'));
